module.exports = __webpack_public_path__ + "img/orange-grain.bc01e9fa.png";